<script setup lang="ts">

</script>

<template>
  <nav class="grid grid-cols-5 overflow-hidden rounded-t-xl bg-primary-200 text-primary-500">
    <!-- <app-button :to="{name: 'home'}">
      <fa-icon icon="i-far-house" />
      <span class="label">Home</span>
    </app-button> -->
    <app-button :to="{name: 'table'}">
      <fa-icon icon="i-material-symbols-table-bar-outline" />
      <span class="label">Meja</span>
    </app-button>
    <app-button :to="{name: 'invitation'}">
      <fa-icon icon="i-far-envelope" />
      <span class="label">Undangan</span>
    </app-button>
    <app-button :to="{name: 'wishes'}">
      <fa-icon icon="i-far-comments" />
      <span class="label">Wishes</span>
    </app-button>
    <app-button :to="{name: 'scan arrival'}">
      <!-- <fa-icon icon="i-far-location-check" /> -->
      <fa-icon icon="i-far-barcode-read" />
      <span class="label">Arrival</span>
    </app-button>
    <app-button :to="{name: 'gallery'}">
      <fa-icon icon="i-far-images" />
      <span class="label">Galeri</span>
    </app-button>
    <!-- <app-button :to="{name: 'team member'}">
      <fa-icon icon="i-far-user" />
      <span class="label">Tim</span>
    </app-button> -->
  </nav>
</template>

<style lang="postcss" scoped>
  nav a {
    @apply flex flex-col items-center gap-1 text-sm;
    @apply pb-1 pt-2 px-2;

    span.label {
      @apply text-2.5 leading-3;
    }

    &.router-link-active {
      @apply text-white bg-primary-500;
    }
  }
</style>
